exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".purchase-fin-table {\n  background: white;\n  padding: 20px 40px;\n}\n.purchase-fin-table .react-bs-table-bordered {\n  border-radius: 5px;\n}\n.purchase-fin-table th {\n  font-size: larger;\n}\n.purchase-fin-table .fin-table-highlight {\n  background: yellow;\n}\n", ""]);

// exports
